<template>
  <div id="gfGuide">
    <div id="gf_guide-icon">
      <svg fill="#72797e" height="36" viewBox="0 0 24 24" width="36" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h24v24H0z" fill="none" />
        <path
          d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z" />
      </svg>
    </div>
    <div id="gf_guide-content"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'Guide',
  data: () => ({}),
  created() {
    this.$center.guide = this;
  },
  methods: {},
});
</script>

<style lang="scss">
#gfGuide {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 99999;
  width: 260px;

  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.3);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid #c0c0c0;
  color: #72797e;
  cursor: default;
  font-size: 0.9em;
  padding: 15px 25px;

  display: none !important;

  svg {
    display: inline;
    vertical-align: unset;
  }

  &:before {
    border-right-color: rgba(0, 0, 0, 0.3);
    margin-top: -9px;
    top: 50%;

    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;

    right: 100%;
  }

  #gf_guide-icon {
    float: left;
    font-size: 36px;
    line-height: 45px;
    margin-right: 12px;
    margin-left: -10px;
  }

  #gf_guide-content {
    font-size: 14px;
    color: #72797e;
    line-height: 1.5;
  }
}
</style>
